<template>
	<div class="col-12">
		<div class="element-wrapper">
			<div class="element-actions">
				<a href="javascript:;" @click="regenerateAllMatchBets(matchId)" class="btn btn-outline-danger">
					{{ t.reset_all_bets }}
				</a>
				<a href="javascript:;" @click="cancellAllMatchBets(matchId)" class="btn btn-outline-primary">
					{{ t.cancel_all_bets }}
				</a>
			</div>
			<h6 class="element-header">Bet stats</h6>
			<div class="element-content">
				<div class="row">
					<div class="col-sm-4 col-xxxl-3">
						<a class="element-box el-tablo" href="javascript:;">
							<div class="label">Total Bet Coupons</div>
							<div class="value">{{ nFormatter(data.totalCoupons) }}</div>
						</a>
					</div>
					<div class="col-sm-4 col-xxxl-3">
						<a class="element-box el-tablo" href="javascript:;">
							<div class="label">Total Bets</div>
							<div class="value">{{ nFormatter(data.totalBets) }}</div>
						</a>
					</div>
					<div class="col-sm-4 col-xxxl-3" v-if="data.totalBetAmount.length > 0">
						<a class="element-box el-tablo" href="javascript:;">
							<div class="label">Total Bet Amount</div>
							<div class="value">{{ nFormatter(data.totalBetAmount.totalamount) }} ({{ nFormatter(data.totalBetAmount.average) }})</div>
						</a>
					</div>
					<div class="d-none d-xxxl-block col-xxxl-3">
						<a class="element-box el-tablo" href="javascript:;">
							<div class="label">Total Player</div>
							<div class="value">{{ nFormatter(data.totalPlayers) }}</div>
						</a>
					</div>
					<div class="d-none d-xxxl-block col-xxxl-3">
						<a class="element-box el-tablo" href="javascript:;">
							<div class="label">Total Odds</div>
							<div class="value">{{ nFormatter(data.totalBetOdd) }}</div>
						</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    import betManager from '@/mixins/betmanager'
    import formatter from '@/mixins/formatter'

    export default {
        name: 'betStats',
	    mixins: [betManager, formatter],
	    props: ['matchId'],
        data () {
            return {
                t: this.$root.t,
                data: null
            }
        },
	    mounted () {
            this.fetchMatchBetStat(this.matchId).then(response => {
				this.data = response.body.result;
            })
	    },
	    methods: {

	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/stats/odds/betStats.vue